var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoft3652022(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "image-2",
    fill: "none",
    viewBox: "4 2 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Microsoft 365 logo (2022)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 3.02588L19.8595 3.16179C19.5021 3.37799 19.1654 3.61972 18.8512 3.88385L19.4993 3.42798H25L26 11L21 16L16 19.4754V23.4829C16 26.2819 17.4629 28.8774 19.8574 30.3268L25.1211 33.5129L14 40.0002H11.8551L7.85737 37.5804C5.46286 36.131 4 33.5355 4 30.7365V17.2606C4 14.4607 5.46379 11.8645 7.85952 10.4154L19.8595 3.15687C19.9339 3.11189 20.0088 3.06823 20.0842 3.02588Z",
    fill: "url(#paint0_radial_2994_8373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0842 3.02588L19.8595 3.16179C19.5021 3.37799 19.1654 3.61972 18.8512 3.88385L19.4993 3.42798H25L26 11L21 16L16 19.4754V23.4829C16 26.2819 17.4629 28.8774 19.8574 30.3268L25.1211 33.5129L14 40.0002H11.8551L7.85737 37.5804C5.46286 36.131 4 33.5355 4 30.7365V17.2606C4 14.4607 5.46379 11.8645 7.85952 10.4154L19.8595 3.15687C19.9339 3.11189 20.0088 3.06823 20.0842 3.02588Z",
    fill: "url(#paint1_linear_2994_8373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19V23.4803C32 26.2793 30.5371 28.8748 28.1426 30.3242L16.1426 37.5878C13.6878 39.0737 10.6335 39.1273 8.1355 37.7487L19.8573 44.844C22.4039 46.3855 25.5959 46.3855 28.1426 44.844L40.1426 37.5803C42.5371 36.1309 43.9999 33.5354 43.9999 30.7364V27.5L42.9999 26L32 19Z",
    fill: "url(#paint2_radial_2994_8373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19V23.4803C32 26.2793 30.5371 28.8748 28.1426 30.3242L16.1426 37.5878C13.6878 39.0737 10.6335 39.1273 8.1355 37.7487L19.8573 44.844C22.4039 46.3855 25.5959 46.3855 28.1426 44.844L40.1426 37.5803C42.5371 36.1309 43.9999 33.5354 43.9999 30.7364V27.5L42.9999 26L32 19Z",
    fill: "url(#paint3_linear_2994_8373)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1405 10.4153L28.1405 3.15678C25.6738 1.66471 22.6021 1.61849 20.0979 3.01811L19.8595 3.16231C17.4638 4.61143 16 7.20757 16 10.0075V19.4914L19.8595 17.1568C22.4051 15.6171 25.5949 15.6171 28.1405 17.1568L40.1405 24.4153C42.4613 25.8192 43.9076 28.2994 43.9957 30.9985C43.9986 30.9113 44 30.824 44 30.7364V17.2605C44 14.4606 42.5362 11.8644 40.1405 10.4153Z",
    fill: "url(#paint4_radial_2994_8373)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1405 10.4153L28.1405 3.15678C25.6738 1.66471 22.6021 1.61849 20.0979 3.01811L19.8595 3.16231C17.4638 4.61143 16 7.20757 16 10.0075V19.4914L19.8595 17.1568C22.4051 15.6171 25.5949 15.6171 28.1405 17.1568L40.1405 24.4153C42.4613 25.8192 43.9076 28.2994 43.9957 30.9985C43.9986 30.9113 44 30.824 44 30.7364V17.2605C44 14.4606 42.5362 11.8644 40.1405 10.4153Z",
    fill: "url(#paint5_linear_2994_8373)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00428 30.9984C4.00428 30.9984 4.00428 30.9984 4.00428 30.9984Z",
    fill: "url(#paint6_radial_2994_8373)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00428 30.9984C4.00428 30.9984 4.00428 30.9984 4.00428 30.9984Z",
    fill: "url(#paint7_linear_2994_8373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2994_8373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4186 10.6383) rotate(110.528) scale(33.3657 58.1966)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06441,
    stopColor: "#AE7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2994_8373",
    x1: 17.5119,
    y1: 37.8685,
    x2: 12.7513,
    y2: 29.6347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2994_8373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.4299 36.3511) rotate(-8.36717) scale(31.0503 20.5108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133928,
    stopColor: "#D59DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E438F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2994_8373",
    x1: 40.3566,
    y1: 25.3768,
    x2: 35.2552,
    y2: 32.6916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#493474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C66BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2994_8373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.0552 26.504) rotate(-165.772) scale(24.9228 41.9552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0584996,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2994_8373",
    x1: 16.9758,
    y1: 3.05655,
    x2: 24.4868,
    y2: 3.05655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2D3F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2994_8373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.0552 26.504) rotate(-165.772) scale(24.9228 41.9552)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0584996,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2994_8373",
    x1: 16.9758,
    y1: 3.05655,
    x2: 24.4868,
    y2: 3.05655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2D3F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft3652022);
export default __webpack_public_path__ + "static/media/Microsoft_365_(2022).d68a486d7f6043792ab006f7b2454557.svg";
export { ForwardRef as ReactComponent };